export default __webpack_public_path__ + "static/media/default-header-background-mobile.c2b55f51.svg";